/* Support tickets — the subjects, the statuses and the word count. */

/* Transcribed verbatim, order included — the value submitted is the label. */
export const SUPPORT_SUBJECTS = [
  "Unable to claim a business",
  "Unable to verify a business",
  "Payment Inquiry",
  "Product Assistance",
  "Technical Glitch",
  "Order Tracking",
  "Cancellation",
  "Website Navigation",
  "Complaint",
  "Other",
];

/* Transcribed from RequestItem, which keys off `status` and defaults to "pending" when there is none. */
export const TICKET_STATES = {
  closed: { label: "Resolved", tone: "success" },
  progress: { label: "In progress", tone: "warning" },
  hold: { label: "Pending", tone: "warning" },
  raised: { label: "Request sent", tone: "info" },
};

export const DECLINED = { label: "Declined (refund initiated)", tone: "danger" };

export const ticketState = (status) => TICKET_STATES[status || "pending"] || DECLINED;

/* The live form's label says "max 100 words" and nothing counts them. */
export const WORD_LIMIT = 100;

export const countWords = (text) =>
  String(text || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;

export const isOverWordLimit = (text) => countWords(text) > WORD_LIMIT;

/* Transcribed from the live upload: what the S3 helper is given and what the
   design tells the user it accepts. */
export const ACCEPTED_FILE_TYPES = ".jpg,.jpeg,.png,.pdf";
export const ACCEPTED_FILE_LABEL = "JPG, JPEG, PNG, PDF — up to 5 MB each";
export const MAX_FILE_BYTES = 5 * 1024 * 1024;

/* The design states a 5 MB cap. The live form states none and enforces none,
   so an oversized file is REPORTED here rather than silently rejected — the
   server stays the authority on what it will take. */
export const isTooLarge = (file) => Boolean(file) && file.size > MAX_FILE_BYTES;

/* When the ticket was raised. `date_of_issue` is a bare DateField, which a
   client parses as midnight UTC — so a ticket raised a minute ago aged to
   "about 7 hours ago" by mid-morning. `created_at` is the same moment to the
   second; it is null on tickets raised before it was recorded, which is the
   only reason the old field is still read at all. */
export const ticketRaisedAt = (ticket) =>
  ticket?.created_at || ticket?.date_of_issue || null;

/* Transcribed: a ticket's own reference is its numeric supportID. The design
   writes "#TRX-4790"; nothing generates that prefix, so the number is shown
   with a plain hash. See F-035. */
export const ticketRef = (ticket) => {
  const id = ticket?.supportID ?? ticket?.id;
  return id ? `#${id}` : "";
};
